import { InjectionToken } from '@angular/core';

export type SupportedEntityPropertyType = 'string' | 'boolean' | 'number' | 'date' | 'html';

export interface EntityProperty<T = any> {
  title: string;
  type: SupportedEntityPropertyType;
  isHiddenFromList: boolean;
  isFilterable: boolean;
  sort?: boolean;
  valuePrepareFunction?: (value: any) => string;
  data?: T;
}

export const FILTER_COLUMN_DATA = new InjectionToken<EntityProperty>('ADM_FILTER_COLUMN_DATA');
